<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="任务详情"
        v-loading="loading"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12">
                        <div class="label">所属项目：</div>
                        <div class="content">{{ msg.project_name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">指派人：</div>
                        <div class="content">{{ msg.appointor_cn_all }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">计划时间：</div>
                        <div class="content">{{ msg.start_time }} 至 {{ msg.end_time }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">优先级：</div>
                        <div class="content">
                            <p
                                class="priority"
                                :class="[
                                msg.priority == 1
                                    ? 'priority1'
                                    : msg.priority == 2
                                    ? 'priority2'
                                    : msg.priority == 3
                                    ? 'priority3'
                                    : msg.priority == 4
                                    ? 'priority4'
                                    : '',
                            ]"
                            >{{ msg.priority }}</p>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">任务类型：</div>
                        <div class="content">{{ msg.type_cn }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">任务状态：</div>
                        <div class="content">
                            <el-tag
                                size="mini"
                                :type="
                                    msg.status == 1
                                        ? 'info'
                                        : msg.status == 5
                                        ? 'warning'
                                        : msg.status == 10 ||
                                          msg.status == 20
                                        ? 'success'
                                        :  msg.status == 99
                                        ? 'danger'
                                        : ''
                                "
                            >{{ msg.status_cn }}</el-tag>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">任务标题：</div>
                        <div class="content" style="font-weight: bold">{{ msg.title }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="min-height: 320px">
                        <div class="label">任务内容：</div>
                        <div class="content">
                            <vue-tinymce
                                v-if="detailVisible"
                                v-model="msg.content"
                                :setting="settingReadoly"
                            />
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">备注：</div>
                        <div class="content">{{ msg.remark }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">创建人：</div>
                        <div class="content">{{ msg.user_name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">创建时间：</div>
                        <div class="content">{{ msg.create_time }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" v-if="msg.files">
                        <div class="label">附件内容：</div>
                        <div class="content link" @click="download(msg.files)">{{ msg.files }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">完成时间：</div>
                        <div class="content">{{ msg.complete_time }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">结束时间：</div>
                        <div class="content">{{ msg.close_time }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">总耗时：</div>
                        <div class="content">
                            <span v-if="msg.total_time">{{ msg.total_time }} h</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">总超天数：</div>
                        <div class="content" style="color: red">
                            <span v-if="msg.overtime">{{ msg.overtime }} 天</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-table
                            border
                            :data="tableData"
                            ref="tableData"
                            highlight-current-row
                            :cell-style="{fontSize:'12px'}"
                            :header-cell-style="{fontSize:'12px'}"
                        >
                            <el-table-column label="指派人" property="user_name" align="center"></el-table-column>
                            <el-table-column label="开始时间" property="start_time" align="center"></el-table-column>
                            <el-table-column label="完成时间" property="end_time" align="center"></el-table-column>
                            <el-table-column label="总时长" property="total_time" align="center"></el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <!-- <el-row v-for="(item,i) of commentList" :key="i" style="height:68px">
                    <el-col :span="24">
                      <div class="comment-list">
                        <div class="cl-title">{{item.create_time}} ,由{{item.user_name}}评价</div>
                        <div class="cl-content">{{ item.comment }}</div>
                      </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="min-height:320px">
                        <div class="label">评价：</div>
                        <div class="content">
                            <vue-tinymce
                                v-if="detailVisible"
                                v-model="msg.comment"
                                :setting="setting"
                            />
                        </div>
                    </el-col>
                </el-row>-->
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >-->
            <el-button size="small" @click="detailVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
import fileUpload from "@/comon/components/fileUpload.vue";
export default {
    data() {
        return {
            msg: {
                comment: ""
            },
            file: [],
            commentList: [],
            tableData: []
        };
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.job();
                    this.jobComment();
                    this.jobDetail();
                }
            }
        }
    },
    created() {},
    methods: {
        /**
         * 保存
         */
        save() {
            this.jobComment(this.msg.comment);
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        job() {
            oaApi.job({}, "get", this.tableItem.id).then(res => {
                //console.log(res);
                if (res.code == 200) {
                    this.msg = res.data;
                    this.file = [
                        {
                            name: res.data.files.split("/")[
                                res.data.files.split("/").length - 1
                            ],
                            url: res.data.files
                        }
                    ];
                }
            });
        },
        jobComment(comment) {
            //console.log(comment);
            oaApi
                .jobComment(
                    { job_id: this.tableItem.id, comment },
                    comment ? "post" : "get"
                )
                .then(res => {
                    //console.log(res);
                    if (res.code == 200) {
                        this.commentList = res.data;
                        if (comment) this.closeDialog();
                    }
                });
        },
        /**
         * 下载文件
         */
        download(url) {
            window.open(url);
        },
        /**
         * 获取指派人列表
         */
        jobDetail() {
            oaApi.jobDetail({ job_id: this.tableItem.id }, "get").then(res => {
                //console.log(res);
                if (res.code == 200) {
                    this.tableData = res.data;
                }
            });
        }
    },
    components: {
        fileUpload
    },
    computed: {
        ...mapState({
            wwwUrl: state => state.index.wwwUrl,
            setting: state => state.index.setting
        }),
        settingReadoly() {
            let obj = JSON.parse(JSON.stringify(this.setting));
            obj.readonly = true;
            return obj;
        }
    }
};
</script>

<style lang="scss" scoped>

</style>